/**
 * routePath.js — the current pathname, readable during render on both sides.
 *
 * Reading window.location during render breaks build-time prerendering: the
 * server has no window, so it takes the fallback branch while the browser takes
 * the real one, the two renders disagree, and React throws away the prerendered
 * DOM (hydration error #418/#425). App.jsx already tracks the path in state and
 * publishes it here, so components derive route-dependent markup from the same
 * value the prerender used.
 *
 * The window fallback covers trees mounted without App — notably the Chrome
 * extension's side panel, which renders AIMail directly.
 */
import { createContext, useContext } from 'react';

export const RoutePathContext = createContext(null);

export function useRoutePath() {
  const fromRouter = useContext(RoutePathContext);
  if (fromRouter != null) return fromRouter;
  return typeof window !== 'undefined' ? window.location.pathname : '/';
}
